import {Injectable} from '@angular/core';
import {MedicalRecordProblemModel} from '../../api/model/medicalRecordProblem.model';
import {EntityCollectionServiceBase} from '@ngrx/data';
import {
    MedicalRecordVisitReasonRepository
} from '../../../visit-reason/impl/service/ngrx/medicalRecordVisitReason.repository';
import {AbstractDeleteOneService} from '../../../../../core/service/v2/service/delete/abstractDeleteOne.service';
import {MedicalProblemRepository} from './ngrx/medicalProblem.repository';
import {MedicalProblemDataServiceAdapter} from './ngrx/medicalProblemDataService.adapter';

@Injectable()
export class MedicalProblemDeleteService extends AbstractDeleteOneService<MedicalRecordProblemModel, MedicalRecordProblemModel>{

    constructor(private service: MedicalProblemRepository,
                public dataService: MedicalProblemDataServiceAdapter,
                public visitReasonService: MedicalRecordVisitReasonRepository) {
        super(service, dataService);
    }
    protected getRepositoriesToSynchronize(): EntityCollectionServiceBase<any>[] {
        return [this.visitReasonService];
    }
}
